import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from 'primereact/button';
import { handlePatchRequest } from '../../service/PatchTemplate';
import { endPoints } from '../../Config';

// One deliberate click, no form: identity and audit time come from the server.
export default function FinanceReadyButton({ complaintId, label = 'Lista', onSaved }) {
    const dispatch = useDispatch();
    const inFlight = useRef(false);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const markReady = async () => {
        if (inFlight.current) return;
        inFlight.current = true;
        setBusy(true); setError('');
        try {
            const response = await dispatch(handlePatchRequest(
                { action: 'mark_ready', confirmed: true },
                endPoints.financeComplaintRefundAction(complaintId), true, true
            ));
            if (response?.status !== 200) {
                setError(response?.data?.message || 'No se pudo marcar como listo. Actualice la lista.');
                return;
            }
            await onSaved();
        } catch (_) { setError('No se pudo confirmar el cambio. Actualice la lista antes de reintentar.'); }
        finally { inFlight.current = false; setBusy(false); }
    };
    return <div><Button label={label} icon="pi pi-check" className="p-button-sm p-button-success" loading={busy} disabled={busy} onClick={markReady} />{error && <small role="alert" className="block text-red-600">{error}</small>}</div>;
}
